<template>
  <nav class="navbar header-bla d-none d-lg-block">
    <div class="container ps-lg-5 pe-lg-5">
      <a title="Bangkok Life Assuarance">
        <router-link to="/" class="navbar-brand">
          <img
            src="@/assets/images/BangkokLife_Logo_NewCI_Header.svg"
            style="width: 160px; height: 50px"
          />
        </router-link>
        <label class="font-family text-decoration-underline blue-1" style="cursor: pointer;" @click="DownloadMenual()">คู่มือการใช้งานระบบ</label>
        
      </a>
      <ul v-if="this.$store.state.UserName !== ''" class="nav d-lg-flex justify-content-between align-items-center">
        
        <li class="nav-item d-none d-md-block d-lg-block">
          <img src="@/assets/images/icon-profile.svg" />
        </li>
        <li class="nav-item d-none d-md-block d-lg-block font-family pe-3 blue-1 fs-4 fw-normal">
          {{ this.$store.state.UserName }}
        </li>
        <li class="authentication">
          <font-awesome-icon :icon="IconLogout" />
          <span class="font-family fs-4 fw-normal" @click="Logout()">Logout</span>
        </li>
      </ul>
    </div>
  </nav>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

import http from "@/services/AuthService";
import LoadingBs5 from "@/components/frontend/LoadingBs5";


export default {
  name: "Nav",
  data: function () {
    return {
      IconLogout: faSignOutAlt,
      nuser_id: "",
      fullname: "",
      Loading: false,
    };
  },
  components: {
    FontAwesomeIcon,
    LoadingBs5
  },
  methods: {
    Logout() {
      // document.cookie = "Token" +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      localStorage.removeItem("Token");
      localStorage.removeItem("AuthorizeToken");
      window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
    },
    DownloadMenual() {
      this.Loading = true;
      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      http.get("AgencyERequest/GetFileManual",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => { 
        if(response.status == 200) {
          const linkSource = `data:${response.data.ContentType};base64,${response.data.FileData}`;          
          const downloadLink = document.createElement('a');
          document.body.appendChild(downloadLink);

          downloadLink.href = linkSource;
          downloadLink.target = '_self';
          downloadLink.download = response.data.FileName;
          downloadLink.click();

          this.Loading = false;
        }
      }).catch((error) => { 
        this.Loading = false;
      });
    },
    dataURLtoFile(data) {
      var bstr = atob(data.FileData);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
            
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], data.FileName, {type:data.ContentType});
    }
  },
  mounted() {},
};
</script>

<style scoped>
  .a {
    cursor: pointer;
  }
</style>